import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'

import { store } from '../store'

import Loader from './Loader'
import NewOrder from './NewOrder'
import RefreshToken from './RefreshToken'

const Login = React.lazy(() => import('./Login'))
const Orders = React.lazy(() => import('./Orders'))
const History = React.lazy(() => import('./History'))
const Menu = React.lazy(() => import('./Categories'))
const Order = React.lazy(() => import('./Order'))

const App = (): JSX.Element => (
  <Provider store={store}>
    <Router>
      <RefreshToken>
        <NewOrder />
        <React.Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/history" element={<History />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/loader" element={<Loader />} />
            <Route path="/order/:orderId" element={<Order />} />
            <Route path="*" element={<Navigate to="/orders" replace />} />
          </Routes>
        </React.Suspense>
      </RefreshToken>
    </Router>
  </Provider>
)

export default App
